import axios from "axios";

const processesAPI = {
  createInitiative: (body) => axios.post("CreateInitiative", body),
  createKPI: (body) => axios.post("CreateKPI", body),
  kpiChangeRequest: (body) => axios.post("KPIChangeRequest", body),
  getRequestById: (id) => axios.get(`Request/${id}`),
};

export default processesAPI;
